import { createReducer, on } from '@ngrx/store';
import { deleteBillerFailure, deleteBillerSuccess, loadBillerBeneficiaries, loadBillerBeneficiariesFailure, loadBillerBeneficiariesSuccess, loadBillers, loadBillersFailure, loadBillersSuccess, loadPendingBillsFailure, loadPendingBillsSuccess, updateBillerFailure, updateBillerSuccess } from './actions';
import { initialBillersInitialState } from './state';

export const BILLERS_FEATURE_KEY = 'billers';
export const BILLERS_BENEFICIARIES_FEATURE_KEY = 'billerBeneficiaries';
export const PENDING_BILLS_FEATURE_KEY = 'pendingBills';

// Load biller beneficiaries
export const billerBeneficiariesReducer = createReducer(
  initialBillersInitialState,
  on(loadBillerBeneficiaries, (state) => {
    return {
      ...state
    }
  }),
  on(loadBillerBeneficiariesSuccess, (state, { billerBeneficiaries }) => ({
    ...state,
    billerBeneficiaries
  })),
  on(loadBillerBeneficiariesFailure, (state, action) => {
    return {
      ...state,
      error: action.error,
    };
  })
);


// Load billers
export const billersReducer = createReducer(
  initialBillersInitialState,
  on(loadBillers, (state) => {
    return {
      ...state
    }
  }),
  on(loadBillersSuccess, (state, { billers }) => ({
    ...state,
    billers
  })),
  on(loadBillersFailure, (state, action) => {
    return {
      ...state,
      error: action.error,
    };
  })
);

// Update biller

export interface UpdateBillerState {
  error: any;
  updatedBillerDetails: any[];
}

export const initialUpdateBillerState: UpdateBillerState = {
  error: null,
  updatedBillerDetails: [],
};

export const updateBillerReducer = createReducer(
  initialUpdateBillerState,
  on(updateBillerSuccess, (state: any, action: any) => {
    return {
      ...state,
      updatedBillerDetails: [...state.updatedBillerDetails, { ...action.updatedBillerDetails }],
    };
  }),
  on(updateBillerFailure, (state, action) => {
    return {
      ...state,
      error: action.error,
    };
  })
);

// Delete biller

export interface DeleteBillerState {
  error: any;
}

export const initialDeleteBillerState: DeleteBillerState = {
  error: null
};

export const deleteBillerReducer = createReducer(
  initialDeleteBillerState,
  on(deleteBillerSuccess, (state: any) => {
    return {
      ...state
    };
  }),
  on(deleteBillerFailure, (state, action) => {
    return {
      ...state,
      error: action.error,
    };
  })
);

// Load pending bills
export interface LoadPendingBillsState {
  error: any;
  pendingBills: any[];
  responseMessage: string;
}

export const initialLoadPendingBillsState: LoadPendingBillsState = {
  error: null,
  pendingBills: [],
  responseMessage: ""
};

export const loadPendingBillsReducer = createReducer(
  initialLoadPendingBillsState,
  on(loadPendingBillsSuccess, (state, { pendingBills, responseMessage }) => ({
    ...state,
    pendingBills,
    responseMessage
  })),
  on(loadPendingBillsFailure, (state, action) => {
    return {
      ...state,
      error: action.error,
    };
  })
);